import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Kurs } from '../_models/kurs';
import { Klassenbuch } from '../_models/klassenbuch';
import { InhalteService } from '../_services/inhalte.service';
import { KursService } from '../_services/kurs.service';

@Component({
  selector: 'add-courseentry',
  templateUrl: './add-courseentry.component.html',
  styles: []
})
export class AddCourseentryComponent implements OnInit {

  constructor(private contentService: InhalteService, private courseService: KursService) {

  }

  trainerList: string[] = [];

  ngOnInit() {
    this.courseService.getTrainerList().subscribe(
      TrainerList => this.trainerList = TrainerList,
      err => console.log(err),
      () => console.log(this.trainerList)
    );
  }

  @Input()
  selectedCourses: Kurs[];

  @Input()
  set courseEntry(value: Klassenbuch) {
    if (value)
      this.classBookEntry = value;
    else {
      this.classBookEntry = new Klassenbuch(new Date());
      this.classBookEntry.trainer = "Trainer";
      this.classBookEntry.thema = "Thema";
      this.classBookEntry.inhalte = "Inhalte";
    }
  }

  classBookEntry: Klassenbuch;

  @Output()
  Saved: EventEmitter<Klassenbuch> = new EventEmitter<Klassenbuch>();

  btnSave() {
    console.log(this.classBookEntry);
    this.contentService.postInhalte(this.classBookEntry).subscribe(
      x => this.classBookEntry = x,
      err => console.log(err),
      () => {
        this.selectedCourses.forEach((sc) => {
          this.contentService.postLookup({ kursnummer: sc.kursNr, klassenbuchnummer: this.classBookEntry.klassenbuchNr }).subscribe(
            x => { },
            err => console.log(err),
            () => { }
          );
        });
        this.Saved.emit(this.classBookEntry);
      }
    );

  }

  @Output()
  Canceled: EventEmitter<boolean> = new EventEmitter<boolean>();

  btnCancel() {
    this.Canceled.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/_components/add-courseentry.component.ts